import CarouselComponent from "../lib/carousel_component";

export const CarouselDotConfig = {
    componentTypeKey: 'CarouselDot',
    baseHtmlClass: 'carousel__dot',
    selector: '.carousel__dot',
    activeClassModifier: 'active',
};

export class CarouselDot extends CarouselComponent {
    
    static createElement() {
        const element = document.createElement('button');
        element.className = CarouselDotConfig.baseHtmlClass;
        element.setAttribute('type', 'button');
        return element;
    }

    static get config() {
        return CarouselDotConfig;
    }

    constructor(id_or_element, carousel, slideIndex) {
        super(id_or_element, carousel, CarouselDotConfig);
        
        this.carousel = carousel;
        this.slideIndex = slideIndex;
        this.isActive = this.element.classList.contains(CarouselDotConfig.activeClassModifier);

        this.element.addEventListener('click', this.handleClick.bind(this));
        this.render();
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.carousel.goToSlide(this.slideIndex);
    }

    setActive(active) {
        this.isActive = active;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.isActive, CarouselDotConfig.activeClassModifier);
    }
}